/** Canonical hosted web app — the default share origin when none is configured. */
const DEFAULT_WEB_ORIGIN = 'https://app.nulanotes.com';

/**
 * Resolve the base URL for a shareable link. Share links always point at the
 * web app.
 *
 * On desktop, `window.location.origin` is `tauri://localhost` (or the Tauri
 * dev server, e.g. `:5173`) — never a URL a recipient can open. So desktop
 * uses the configured hosted web origin (`VITE_DESKTOP_WEB_ORIGIN`), and when
 * that is unset (e.g. local dev) defaults to the canonical production web app
 * rather than the location origin — the link is always an openable web link.
 * On web, the current location origin is already the web app origin.
 *
 * Pure function — inject the platform flag and origins so it is testable
 * without the DOM or build-time env. Mirrors `authRedirectUri`.
 */
export function shareBaseUrl(opts: {
  isDesktop: boolean;
  /** Hosted web origin (`VITE_DESKTOP_WEB_ORIGIN`). Empty when unconfigured. */
  webOrigin: string;
  /** `window.location.origin` at the call site (web only). */
  locationOrigin: string;
}): string {
  const { isDesktop, webOrigin, locationOrigin } = opts;
  const base = isDesktop ? webOrigin || DEFAULT_WEB_ORIGIN : locationOrigin;
  return base.replace(/\/$/, '');
}
